import { QuestionMetadata, QuestionData } from '@stratascratch/ui'
import type { Table } from '@stratascratch/ui/components/DatasetTableTypes'
import { PLATFORM_BASE_URL } from '../constants'

type QuestionClass =
  | 'Coding Question'
  | 'Algorithm Question'
  | 'Visual Question'
interface Props {
  value: {
    questionClass: QuestionClass
    codeType?: 'PgSQL' | 'Python'
    questionId: string
    title: string
    url: string
    date?: string | null
    companies?: string[]
    jobPositions?: string[]
    difficulty: number
    pythonDifficulty?: number
    questionType?: string
    question: string
    tables?: Table[]
    pythonOutputType?: string
    description?: string
    defaultCodeMatplotlib?: string
  }
}

function QuestionDetails({ value }: Props) {
  const {
    questionClass,
    codeType,
    title,
    url,
    questionId,
    date,
    companies,
    jobPositions,
    difficulty,
    questionType,
    question,
    tables,
    pythonOutputType,
  } = value

  if (!title) {
    return (
      <p>
        Question Details: something went wrong while looking for that
        question...
      </p>
    )
  }

  let questionUrl = `${PLATFORM_BASE_URL}${url}`

  if (questionClass === 'Coding Question') {
    questionUrl += codeType === 'PgSQL' ? '?code_type=1' : '?code_type=2'
  } else if (questionClass === 'Algorithm Question') {
    questionUrl += '?code_type=1'
  } else if (questionClass === 'Visual Question') {
    questionUrl += '?code_type=2'
  }

  return (
    <div className="my-8 rounded-md bg-slate-50 px-8 py-6">
      <QuestionMetadata
        title={title}
        titleTag="h4"
        url={questionUrl}
        showLock={false}
        id={questionId}
        date={date ? new Date(date) : undefined}
        companyNames={companies}
        jobPositions={jobPositions}
        difficulty={difficulty}
        questionType={questionType}
        question={question}
      />

      {questionClass === 'Coding Question' && tables && (
        <QuestionData
          dataType={codeType === 'Python' ? 'DataFrame' : 'Table'}
          tables={tables}
          pythonOutputType={
            (codeType === 'Python' && pythonOutputType) || undefined
          }
        />
      )}

      {questionClass === 'Visual Question' && tables && (
        <QuestionData
          dataType="DataFrame"
          tables={tables}
          pythonOutputType={pythonOutputType || undefined}
        />
      )}
    </div>
  )
}

export default QuestionDetails
